import Vue from 'vue';
import Router, { Route } from 'vue-router';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Settings from '@/views/Settings.vue';
import Performance from '@/views/Performance.vue';
import SocketTest from '@/views/SocketTest.vue';
import DisplayItemHistory from '@/views/DisplayItemHistory.vue';
import Dev from '@/views/Dev.vue';
import HostSelection from '@/views/HostSelection.vue';
import GlobalEvents from '@/logic/GlobalEvents';

Vue.use(Router);

const router = new Router({
    routes: [
        // {
        //     path: '/',
        //     name: 'login',
        //     component: Login,
        // },
        {
            path: '/',
            name: 'host',
            component: HostSelection,
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
        },
        {
            path: '/about',
            name: 'about',
            component: About,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings
        },
        {
            path: '/performance',
            name: 'performance',
            component: Performance,
        },
        {
            path: '/history',
            name: 'history',
            component: DisplayItemHistory
        },
        {
            path: '/socket-test',
            name: 'socket-test',
            component: SocketTest,
        },
        {
            path: '/dev',
            name: 'dev',
            component: Dev
        },
        {
            path: '/performance/:hostlogin/:linkid/',
            name: 'performance-direct',
            component: Performance,
            props: true
        }
    ],
});

// Routes that should not be included in history
const noHistoryRoutes = [
    'about',
    'settings',
    'dev'
];

router.beforeEach((to: Route, from: Route, next) => {

    // Prevent infinite loop
    if (to.meta.redirectReplace) {
        to.meta.redirectReplace = false;
        next();
        return;
    }

    if (from.name && noHistoryRoutes.includes(from.name)) {

        // Redirect as replace
        if (to.name) {
            to.meta.redirectReplace = true;
            next({ name: to.name, replace: true});
        } else {
            next();
        }
    } else {
        next();
    }
});

// Routes that will keep socket open
const performanceRoutes = [
    'performance',
    'performance-direct',
    'settings',
    'about',
    'dev'
];

router.afterEach((to, from) => {
    if (to.name && !performanceRoutes.includes(to.name)) {
        // Close socket (whether it is open or not)
        GlobalEvents.$emit('leave-performance');
    }
});

export default router;
